import Navbar from "@/components/site/Navbar";
import VideoIntro from "@/components/site/VideoIntro";
import Hero from "@/components/site/Hero";
import OperationalDashboard from "@/components/site/OperationalDashboard";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import Process from "@/components/site/Process";
import Certifications from "@/components/site/Certifications";
import ContactSection from "@/components/site/ContactSection";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-white text-slate-900">
      <Navbar />
      <main>
        <VideoIntro />
        <Hero />
        <OperationalDashboard />
        <Services />
        <About />
        <Process />
        <Certifications />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
